import axios from "axios";
import config from "../config";
import {
  COINRANKING_COINS_PATH,
  MARKETS_COINRANKING_QUERY,
} from "../constants/coinranking";

const parseNum = (value) => {
  if (value == null || value === "") return 0;
  const n = typeof value === "number" ? value : parseFloat(String(value));
  return Number.isFinite(n) ? n : 0;
};

export function mapCoinrankingCoinToMarketRow(raw) {
  const sparkRaw = raw?.sparkline;
  const priceSeries = Array.isArray(sparkRaw)
    ? sparkRaw.map((v) => parseNum(v))
    : [];

  return {
    id: raw.uuid,
    coinGeckoId: raw.coinGeckoId || "",
    rank: parseNum(raw.rank),
    name: raw.name || "",
    symbol: String(raw.symbol || "").toLowerCase(),
    image: raw.iconUrl || "",
    current_price: parseNum(raw.price),
    price_change_percentage_24h: parseNum(raw.change),
    market_cap: parseNum(raw.marketCap),
    total_volume: parseNum(raw["24hVolume"]),
    sparkline_in_7d: { price: priceSeries },
  };
}

/**
 * GET /v2/coins?limit=100&timePeriod=24h
 * @returns {Promise<Array>} нормалізований список монет для таблиці
 */
export async function fetchMarketsCoinsFromCoinranking() {
  const token = config.coinranking_api_key;
  const headers = token ? { "x-access-token": token } : {};

  const { data } = await axios.get(COINRANKING_COINS_PATH, {
    params: {
      limit: MARKETS_COINRANKING_QUERY.limit,
      timePeriod: MARKETS_COINRANKING_QUERY.timePeriod,
    },
    headers,
    timeout: 15000,
  });

  const coins = data?.data?.coins;
  if (!Array.isArray(coins)) {
    return [];
  }

  return coins.map(mapCoinrankingCoinToMarketRow);
}
